<div class="sty-flex-col" *ngIf="loading ==false && ShowSectionQuestions!= true && ShowCompleteMessage==false" style="margin-top: 2%;">
  <div class="sty-flex-col" style="flex:0.1;align-items: center;justify-content: center;">
    <h3>{{SelectedSlide && SelectedSlide.SelectionName?SelectedSlide.SelectionName:"-"}}</h3>
  </div>

  <div class="sty-flex-col" *ngIf="SelectedSlide && SelectedSlide.SlideTypeId == 1"
    style="flex:1;align-items: center;justify-content: center;min-height: 600px;">
    <img *ngIf="SlideImage != ''" [src]="getImage(SlideImage)" alt="No File Uploaded"
      style="width:800px;height: 600px;object-fit:contain;">
    <div *ngIf="SelectedSlide && SelectedSlide.SlideTypeId == 1 &&  SlideImage==''">
      <span>Slide Not Found</span>
    </div>
  </div>



  <div *ngIf="SelectedSlide && SelectedSlide.SlideTypeId > 1" class="sty-flex-col"
    style="flex:1;align-items: center;justify-content: center;min-height: 600px;">
    <iframe *ngIf="SelectedSlide.VideoUrl" width="800" height="560" [src]="getVideo(SelectedSlide.VideoUrl)"
      frameborder="0" allowfullscreen></iframe>
    <span *ngIf="SelectedSlide.VideoUrl == null">Video Url Not Found</span>
  </div>


  <div class="sty-flex-row" style="flex:0.3;justify-content: space-between;align-items: center;margin-top: 20px; margin-top: 2%;">
    <div class="sty-flex-row" style="flex:1"></div>
    <div class="sty-flex-row" style="flex:1;min-width: 50px;align-items: center;justify-content: center;">
      <a *ngIf="ShowSectionQuestionButton" class="button button--primary" (click)="ClickStartSectionQuestion()">
        <span class="button__text">Section Questions</span>
      </a>
    </div>
    <div style="min-width: 100px;flex:1;">
      <div *ngIf="ShowInvalidSlide==false && ShowNextSectionBtn==false" class="sty-flex-row"
        style="flex:1;justify-content: flex-end;">
        <a *ngIf="ShowBackBtn" class="button" (click)="onClickBack()">
          <span class="button__text">Previous</span>
        </a>
        <a *ngIf="ShowNextBtn" class="button" style="margin-left: 20px; " (click)="onClickNext()">
          <span class="button__text">Next</span>
        </a>
      </div>



    </div>

  </div>


</div>


<div class="sty-flex-col" *ngIf="loading ==false && ShowSectionQuestions == true && ShowCompleteMessage==false" style="margin-top: 2%;">
  <div style="min-height: 600px;">
    <mat-list style="display:inline-block; width:50%; text-align:center;"
      *ngFor="let qus of multiplechoiceArray">
      <mat-list-item role="listitem">
        <div style="display: flex;flex-direction: row;align-items: center;">

          <i (click)="ClickQuestionWarning(qus)" class="material-icons button__icon" *ngIf="qus.valid == false"
            style="color: red;cursor: pointer;margin-right: 20px;">warning</i>

          <h5>{{qus.Question}}</h5>
        </div>

      </mat-list-item>

      <mat-list *ngFor="let ans of qus.AnswerList">
        <mat-list-item role="listitem">
          <div style="display: flex;flex-direction: row;">
            <i (click)="ChangeMCAnswer(ans)" *ngIf="ans.userSelectAnswer != true" class="material-icons button__icon"
              style="cursor: pointer;margin-right: 20px;">radio_button_unchecked</i>
            <i (click)="ChangeMCAnswer(ans)" *ngIf="ans.userSelectAnswer == true" class="material-icons button__icon"
              style="cursor: pointer;margin-right: 20px;">radio_button_checked</i>
            <span>{{ans.answer}}</span>
            <!-- <mat-radio-button [checked]="ans.userSelectAnswer" (change)="ChangeMCAnswer(ans)" value="ans.Id">
              {{ans.answer}}</mat-radio-button> -->
          </div>
        </mat-list-item>
      </mat-list>

    </mat-list>
    <mat-list style="display:inline-block; width:50%; text-align:center;"
      *ngFor="let qus of multiplselectionArray">
      <mat-list-item role="listitem">
        <div style="display: flex;flex-direction: row;align-items: center;">

          <i (click)="ClickQuestionWarning(qus)" class="material-icons button__icon" *ngIf="qus.valid == false"
            style="color: red;cursor: pointer;margin-right: 20px;">warning</i>

          <h5>{{qus.Question}}</h5>
        </div>
      </mat-list-item>
      <mat-list *ngFor="let ans of qus.AnswerList">
        <mat-list-item role="listitem">
          <div style="display: flex;flex-direction: row;">
            <mat-checkbox [checked]="ans.userSelectAnswer" (change)="ChangeMSAnswer(ans)" value="ans.Id">{{ans.answer}}
            </mat-checkbox>
          </div>
        </mat-list-item>
      </mat-list>

    </mat-list>
    <mat-list style="display:inline-block; width:50%; text-align:center;"
      *ngFor="let qus of trueFalseArray">
      <mat-list-item role="listitem">
        <div style="display: flex;flex-direction: row;align-items: center;">

          <i (click)="ClickQuestionWarning(qus)" class="material-icons button__icon" *ngIf="qus.valid == false"
            style="color: red;cursor: pointer;margin-right: 20px;">warning</i>

          <h5>{{qus.Question}}</h5>
        </div>
      </mat-list-item>


      <mat-list *ngFor="let ans3 of qus.AnswerList">
        <mat-list-item role="listitem">
          <div style="display: flex;flex-direction: row;">
            <i (click)="ChangeTFAnswer(ans3)" *ngIf="ans3.userSelectAnswer != true" class="material-icons button__icon"
              style="cursor: pointer;margin-right: 20px;">radio_button_unchecked</i>
            <i (click)="ChangeTFAnswer(ans3)" *ngIf="ans3.userSelectAnswer == true" class="material-icons button__icon"
              style="cursor: pointer;margin-right: 20px;">radio_button_checked</i>
            <span>{{ans3.answer}}</span>
            <!-- <mat-radio-button [checked]="ans3.userSelectAnswer" (change)="ChangeTFAnswer(ans3)" value="{{ans3.Id}}">{{ans3.answer}}</mat-radio-button> -->
          </div>
        </mat-list-item>
      </mat-list>

    </mat-list>
  </div>
  <div class="sty-flex-row" style="align-items: center;justify-content: center;">
    <a *ngIf="ShowNextSectionBtn == false " class="button button--primary" style="margin-left: 20px; "
      (click)="onClickSubmit()">
      <span class="button__text">Submit</span>
    </a>
    <a *ngIf="ShowInvalidSlide==false && ShowNextSectionBtn==true" class="button button--primary"
      style="margin-left: 20px; " (click)="onClickShowNextSection()">
      <span class="button__text">Next</span>
    </a>

  </div>

  <div *ngIf="ShowInvalidBanner" style="display: flex;flex-direction: row;align-items: center;justify-content: center;">
    <h5>You did not get all questions correct. Please use the</h5><i
      style="color: red;margin-left: 10px;margin-right: 10px;" class="material-icons">warning</i>
    <h5>to review the relevent slide then return to these questions to amend your answer.</h5>
  </div>

</div>

<div *ngIf="loading ==true"
  style="display: flex;flex-direction: column;align-items: center;justify-content: center;min-height: 800px;align-self: center;">
  <mat-spinner></mat-spinner>
</div>

<div *ngIf="ShowCompleteMessage" class="sty-flex-col"
  style="min-height: 600px;align-items: center;justify-content: center;align-self: center;">
  <span style="font-size: 30px;font-weight: bold;">
    Induction Complete
  </span>

  <span style="font-size: 20px;margin-top: 20px;">
    The Following people have completed an On {{ResultStartInduction && ResultStartInduction.InductionInfo.InductionType}} induction.
  </span>
  <span style="font-size: 20px;align-self: center;">
    {{getDate()}}
  </span>
  <div style="margin-top: 50px;">
    <mat-list role="list">
      <mat-list-item role="listitem" *ngFor="let user of ResultStartInduction.username">
        
        <span style="font-size: 20px;align-self: center;">
          {{user}}
        </span>
      </mat-list-item>

    </mat-list>

    <!-- <div style="align-items: center;
    justify-content: center;
    display: flex;margin-top: 20px;">
      <a class="button button--primary" (click)="OnClickDone()">
        <span class="button__text">Done</span>
      </a>
    </div> -->

  </div>
</div>